import { siteDomain } from '../site';
import type { IUrlVars } from '../vars/url';

export function buildProductionUrls(): IUrlVars {
  const webBase = `https://${siteDomain}`;
  const telegramUrl = `https://tg.${siteDomain}`;
  return {
    identityUrl: `https://identity.${siteDomain}`,
    apiUrl: `https://api.${siteDomain}`,
    webUrl: webBase,
    loginUrl: `${webBase}/login`,
    cookieDomain: `.${siteDomain}`,
    passkeyDomain: siteDomain,
    allowedOrigins: [webBase, telegramUrl],
    catalogUrl: `https://catalog.${siteDomain}`,
    vaultUrl: `https://media-vault.${siteDomain}`,
    vaultApiKey: 'vk-prod-2b8d6f4a1c3e7950',
    telegramUrl,
  };
}
